<p></p>
<div class="page-wrap d-flex flex-row align-items-center">
    <div class="container" style="padding-top: 20px;">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">

                <h1 style="color: #E65400" class="display-1 d-block">ERROR</h1>

                <div class="mb-4 lead">

                <p>Mulesoft API Gateway is not reachable, please contact your administrator</p>
                <p>Mulesoft API Gateway no responde, Por favor contacte a su administrador</p>
                </div>
            <div><br></div>
            </div>

        </div>

    </div>

</div>